export default __webpack_public_path__ + "static/media/j5.843770e3.JPG";